import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'ifc-identity-verification-result-content',
    templateUrl: './identity-verification-result-content.component.html',
    styleUrls: ['./identity-verification-result-content.component.scss'],
    standalone: false
})
export class IdentityVerificationResultComponent {
  @Input() message: string;
  @Input() messageHtml: string;
  @Input() title: string;
  @Output() closePage: EventEmitter<void> = new EventEmitter<void>();

  onClickClose(): void {
    this.closePage.emit();
  }
}
